  <div class="ig-feed-layout">
    <!-- Desktop: coluna esquerda — dicas + atalhos -->
    <aside
      class="ig-feed__rail ig-feed__rail--left"
      [attr.aria-label]="'socialFeed.sidebarLeftAria' | transloco"
    >
      <div class="ig-feed__rail-card ftds-chamfer-bordered">
        <h2 class="ig-feed__rail-title">{{ "socialFeed.sidebarTipsTitle" | transloco }}</h2>
        <p class="ig-feed__rail-tip" [attr.data-tip]="sidebarTipIndex">
          {{ tipTranslationKey | transloco }}
        </p>
        <div class="ig-feed__rail-dots" aria-hidden="true">
          <span
            *ngFor="let _ of sidebarTipIndices; let i = index"
            class="ig-feed__rail-dot"
            [class.ig-feed__rail-dot--active]="i === sidebarTipIndex"
          ></span>
        </div>
      </div>
    </aside>

    <div class="ig-feed ig-feed__main">
    <!-- TOP BAR: create + search + profile -->
    <div class="ig-feed__top-bar">
      <button class="ig-feed__create-btn" (click)="openCreate()">
        <div class="ig-feed__create-icon"><i class="pi pi-plus"></i></div>
        <span>{{ "socialFeed.newPost" | transloco }}</span>
      </button>

      <div class="ig-feed__search">
        <div class="ig-feed__search-combo">
          <div class="ig-feed__search-input-wrapper ftds-chamfer-bordered">
            <i class="pi pi-search ig-feed__search-icon"></i>
            <input
              type="search"
              name="social-feed-user-search"
              autocomplete="off"
              autocorrect="off"
              autocapitalize="off"
              spellcheck="false"
              inputmode="search"
              [(ngModel)]="searchQuery"
              (ngModelChange)="onSearchQueryChange($event)"
              (focus)="onSearchFocus()"
              (blur)="onSearchBlur()"
              [placeholder]="'socialFeed.searchPlaceholder' | transloco"
              (keydown.enter)="searchUser()"
              (keydown.escape)="searchDropdownOpen = false"
              [disabled]="searchLoading"
            />
            <p-progressSpinner
              *ngIf="searchLoading || searchSuggestionsLoading"
              [style]="{ width: '16px', height: '16px' }"
            ></p-progressSpinner>
          </div>
          <div
            class="ig-feed__search-panel"
            *ngIf="searchDropdownOpen"
            role="listbox"
            [attr.aria-label]="'socialFeed.searchSuggestionsAria' | transloco"
          >
            <!-- Seção: Projetos -->
            <ng-container *ngIf="searchSuggestionsProjects.length">
              <div class="ig-feed__search-section-header">
                <i class="pi pi-folder"></i>
                {{ "socialFeed.searchSectionProjects" | transloco }}
              </div>
              <button
                type="button"
                class="ig-feed__search-item ig-feed__search-item--project"
                *ngFor="let p of searchSuggestionsProjects"
                role="option"
                (mousedown)="goToProjectFromSearch(p, $event)"
              >
                <div class="ig-feed__search-thumb">
                  <img *ngIf="p.primaryImageUrl" [src]="p.primaryImageUrl" alt="" />
                  <i *ngIf="!p.primaryImageUrl" class="pi pi-car"></i>
                </div>
                <div class="ig-feed__search-item-text-wrap">
                  <span class="ig-feed__search-item-text">{{ p.projectName }}</span>
                  <span
                    class="ig-feed__search-item-sub"
                    *ngIf="p.vehicleManufacturer || p.vehicleModel"
                  >
                    {{ p.vehicleManufacturer }} {{ p.vehicleModel }}
                  </span>
                </div>
              </button>
            </ng-container>

            <!-- Seção: Pessoas -->
            <ng-container *ngIf="searchSuggestions.length">
              <div class="ig-feed__search-section-header">
                <i class="pi pi-users"></i>
                {{ "socialFeed.searchSectionUsers" | transloco }}
              </div>
              <button
                type="button"
                class="ig-feed__search-item"
                *ngFor="let u of searchSuggestions"
                role="option"
                (mousedown)="goToProfileFromSearch(u, $event)"
              >
                <span class="ig-feed__search-item-text">{{ displayName(u) }}</span>
                <span class="ig-feed__search-following" *ngIf="u.isFollowedByViewer">{{
                  "socialFeed.searchFollowingBadge" | transloco
                }}</span>
              </button>
            </ng-container>

            <div
              class="ig-feed__search-empty"
              *ngIf="searchShowEmptyHint && !searchSuggestionsLoading"
            >
              {{ "socialFeed.searchNoResults" | transloco }}
            </div>
          </div>
        </div>
      </div>

      <button class="ig-feed__profile-btn" (click)="goToMyProfile()" title="Meu perfil">
        <div class="ig-feed__profile-icon"><i class="pi pi-user"></i></div>
        <span>{{ "socialFeed.myProfile" | transloco }}</span>
      </button>
    </div>

    <!-- TABS: Feed / Explorar -->
    <div class="ig-feed__tabs">
      <button
        class="ig-feed__tab"
        [class.ig-feed__tab--active]="activeTab === 'feed'"
        (click)="switchTab('feed')"
      >
        {{ "socialFeed.tabFeed" | transloco }}
      </button>
      <button
        class="ig-feed__tab"
        [class.ig-feed__tab--active]="activeTab === 'explore'"
        (click)="switchTab('explore')"
      >
        {{ "socialFeed.tabExplore" | transloco }}
      </button>
    </div>

    <!-- Sancionado no feed pela moderação (403 SOCIAL_SUSPENDED/SOCIAL_BANNED): aviso fixo no lugar dos toasts -->
    <div class="ig-feed__empty-state" *ngIf="socialAccessBlocked">
      <i class="pi pi-ban"></i>
      <p>{{ (socialAccessBlocked === 'banned' ? 'socialFeed.accessBanned' : 'socialFeed.accessSuspended') | transloco }}</p>
    </div>

    <!-- ========== FEED TAB ========== -->
    <ng-container *ngIf="activeTab === 'feed'">
      <div class="ig-feed__loading" *ngIf="loading && !posts.length">
        <p-progressSpinner [style]="{ width: '48px', height: '48px' }"></p-progressSpinner>
      </div>

      <div class="ig-feed__posts" *ngIf="!loading || posts.length">
        <app-social-post-card
          *ngFor="let p of posts"
          [post]="p"
          [currentUserId]="currentUserId"
          [currentUserAvatarUrl]="currentUserAvatarUrl"
          (postChanged)="onPostChanged()"
          (reportPost)="reportDialog.open('Post', $event)"
          (reportComment)="reportDialog.open('Comment', $event)"
          (reportUser)="reportDialog.open('User', $event)"
          (projectFollowed)="onProjectFollowedFromCard($event)"
        ></app-social-post-card>

        <div #feedSentinel class="ig-feed__sentinel"></div>
        <div class="ig-feed__load-more" *ngIf="loadingMore">
          <p-progressSpinner [style]="{ width: '32px', height: '32px' }"></p-progressSpinner>
        </div>

        <div class="ig-feed__empty-state" *ngIf="!loading && !posts.length">
          <h3 class="ig-feed__empty-title">{{ "socialFeed.emptyFeedTitle" | transloco }}</h3>
          <p>{{ "socialFeed.emptyFeedHint" | transloco }}</p>
          <button class="ig-feed__explore-link" (click)="switchTab('explore')">
            {{ "socialFeed.goExplore" | transloco }}
          </button>
        </div>
      </div>
    </ng-container>

    <!-- ========== EXPLORE TAB ========== -->
    <ng-container *ngIf="activeTab === 'explore'">
      <div class="ig-feed__loading" *ngIf="exploreLoading && !explorePosts.length">
        <p-progressSpinner [style]="{ width: '48px', height: '48px' }"></p-progressSpinner>
      </div>

      <div class="ig-explore-grid" *ngIf="!exploreLoading || explorePosts.length">
        <div
          class="ig-explore-grid__item"
          *ngFor="let p of explorePosts"
          (click)="openExplorePost(p.id)"
        >
          <ng-container *ngIf="exploreThumb(p) as thumb; else noThumb">
            <img [src]="thumb.url" alt="" (error)="markThumbBroken(p.id)" />
          </ng-container>
          <ng-template #noThumb>
            <div class="ig-explore-grid__no-thumb">
              <i class="pi pi-image"></i>
            </div>
          </ng-template>
          <div class="ig-explore-grid__video-badge" *ngIf="isVideoPost(p)">
            <i class="pi pi-play-circle"></i>
          </div>
          <div class="ig-explore-grid__overlay">
            <span><i class="pi pi-heart-fill"></i> {{ p.likesCount }}</span>
            <span><i class="pi pi-comment"></i> {{ p.commentsCount }}</span>
          </div>
        </div>
      </div>

      <div #exploreSentinel class="ig-feed__sentinel"></div>
      <div class="ig-feed__load-more" *ngIf="exploreLoadingMore">
        <p-progressSpinner [style]="{ width: '32px', height: '32px' }"></p-progressSpinner>
      </div>

      <p class="ig-feed__empty" *ngIf="!exploreLoading && !explorePosts.length">
        {{ "socialFeed.emptyExplore" | transloco }}
      </p>
    </ng-container>
    </div>

    <!-- Desktop: coluna direita — em alta (explore, ordenado por curtidas) -->
    <aside
      class="ig-feed__rail ig-feed__rail--right"
      [attr.aria-label]="'socialFeed.sidebarRightAria' | transloco"
    >
      <div class="ig-feed__rail-card ftds-chamfer-bordered">
        <h2 class="ig-feed__rail-title">{{ "socialFeed.sidebarTrendingTitle" | transloco }}</h2>
        <p class="ig-feed__rail-sub">{{ "socialFeed.sidebarTrendingHint" | transloco }}</p>
        <ul class="ig-feed__rail-trending" *ngIf="trendingRailPosts.length">
          <li *ngFor="let p of trendingRailPosts">
            <button
              type="button"
              class="ig-feed__rail-trending-item"
              (click)="openExplorePost(p.id)"
            >
              <span class="ig-feed__rail-trending-thumb">
                <ng-container *ngIf="exploreThumb(p) as th; else noTrendThumb">
                  <img [src]="th.url" alt="" (error)="markThumbBroken(p.id)" />
                </ng-container>
                <ng-template #noTrendThumb>
                  <span class="ig-feed__rail-trending-ph">
                    <i class="pi pi-image"></i>
                  </span>
                </ng-template>
                <span class="ig-feed__rail-trending-video-badge" *ngIf="isVideoPost(p)">
                  <i class="pi pi-play-circle"></i>
                </span>
              </span>
              <span class="ig-feed__rail-trending-meta">
                <span class="ig-feed__rail-trending-author">{{ p.projectName || displayAuthor(p) }}</span>
                <span class="ig-feed__rail-trending-stats">
                  <i class="pi pi-heart-fill"></i> {{ p.likesCount }}
                  <i class="pi pi-comment"></i> {{ p.commentsCount }}
                </span>
              </span>
            </button>
          </li>
        </ul>
        <p class="ig-feed__rail-empty" *ngIf="!trendingRailPosts.length && !exploreLoading">
          {{ "socialFeed.sidebarTrendingEmpty" | transloco }}
        </p>
        <div class="ig-feed__rail-loading" *ngIf="exploreLoading && !explorePosts.length">
          <p-progressSpinner [style]="{ width: '28px', height: '28px' }"></p-progressSpinner>
        </div>
      </div>
      <div class="ig-feed__rail-card ig-feed__rail-card--muted ftds-chamfer-bordered">
        <p class="ig-feed__rail-footnote">{{ "socialFeed.sidebarFootnote" | transloco }}</p>
      </div>
    </aside>
  </div>

  <!-- CREATE POST DIALOG (two-step flow) -->
  <p-dialog
    [(visible)]="createVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [showHeader]="false"
    [closable]="true"
    styleClass="ig-create-dialog"
    [style]="{ width: createStep === 'select' ? '' : 'min(860px, 95vw)', height: createStep === 'select' ? 'auto' : '100%' }"
  >
    <!-- STEP 0a: LOADING PROJECTS -->
    <ng-container *ngIf="loadingMyProjects">
      <div class="ig-create-loading">
        <p-progressSpinner></p-progressSpinner>
      </div>
    </ng-container>

    <!-- STEP 0b: NO PUBLIC PROJECT -->
    <ng-container *ngIf="!loadingMyProjects && createStep === 'noProject'">
      <div class="ig-create-header">
        <span class="ig-create-header__title">{{ "socialFeed.createPost" | transloco }}</span>
        <button class="ig-create-header__close" (click)="createVisible = false">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <div class="ig-create-empty">
        <i class="pi pi-info-circle"></i>
        <h3>{{ "socialFeed.noPublicProjectTitle" | transloco }}</h3>
        <p>{{ "socialFeed.noPublicProjectHint" | transloco }}</p>
        <button class="ig-create-empty__cta" (click)="goCreateProjectFromModal()">
          {{ "socialFeed.goCreateProject" | transloco }}
        </button>
      </div>
    </ng-container>

    <!-- STEP 0c: PICK PROJECT (when 2+ public projects) -->
    <ng-container *ngIf="!loadingMyProjects && createStep === 'pickProject'">
      <div class="ig-create-header">
        <span class="ig-create-header__title">{{ "socialFeed.pickProjectTitle" | transloco }}</span>
        <button class="ig-create-header__close" (click)="createVisible = false">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <ul class="ig-create-projects">
        <li
          *ngFor="let p of myPublicProjects"
          class="ig-create-projects__item"
          (click)="confirmProjectSelection(p.projectId)"
        >
          <div class="ig-create-projects__thumb">
            <img *ngIf="p.primaryImageUrl" [src]="p.primaryImageUrl" alt="" />
            <i *ngIf="!p.primaryImageUrl" class="pi pi-car"></i>
          </div>
          <span class="ig-create-projects__name">{{ p.projectName }}</span>
          <i class="pi pi-chevron-right ig-create-projects__chevron"></i>
        </li>
      </ul>
    </ng-container>

    <!-- STEP 1: SELECT MEDIA -->
    <ng-container *ngIf="!loadingMyProjects && createStep === 'select'">
      <div class="ig-create-header">
        <span class="ig-create-header__title">{{ "socialFeed.createPost" | transloco }}</span>
        <button class="ig-create-header__close" (click)="createVisible = false">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <div
        class="ig-create-dropzone"
        [class.ig-create-dropzone--dragging]="isDragging"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave()"
        (drop)="onDrop($event)"
      >
        <div class="ig-create-dropzone__icon">
          <i class="pi pi-images"></i>
          <i class="pi pi-video"></i>
        </div>
        <p class="ig-create-dropzone__text">{{ "socialFeed.dragMedia" | transloco }}</p>
        <p class="ig-create-dropzone__hint">{{ "socialFeed.videoSizeHint" | transloco }}</p>
        <label class="ig-create-dropzone__btn">
          {{ "socialFeed.selectFromComputer" | transloco }}
          <input type="file" multiple accept=".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp,.mp4,video/mp4" (change)="onFilesSelected($event)" />
        </label>
      </div>
    </ng-container>

    <!-- STEP 2: DETAILS -->
    <ng-container *ngIf="!loadingMyProjects && createStep === 'details'">
      <div class="ig-create-header">
        <button class="ig-create-header__back" (click)="goBackToSelect()" [disabled]="creating">
          <i class="pi pi-arrow-left"></i>
        </button>
        <span class="ig-create-header__title">{{ "socialFeed.createPost" | transloco }}</span>
        <button
          class="ig-create-header__share"
          [class.is-loading]="creating"
          [disabled]="creating"
          (click)="submitCreate()"
        >
          <span class="ig-create-header__share-spinner" *ngIf="creating" aria-hidden="true"></span>
          <span>
            {{ (creating ? 'socialFeed.publishing' : 'socialFeed.share') | transloco }}
          </span>
        </button>
      </div>

      <div class="ig-create-content">
        <!-- LEFT: media preview -->
        <div class="ig-create-preview">
          <div class="ig-create-preview__stage">
            <div
              class="ig-create-preview__media"
              [class.ig-create-preview__media--loading]="isFileVideo(currentPreview) && !previewFrameW"
              [style.width.px]="(isFileVideo(currentPreview) ? previewFrameW : imageFrameW) || undefined"
              [style.height.px]="(isFileVideo(currentPreview) ? previewFrameH : imageFrameH) || undefined"
              (touchstart)="onPreviewTouchStart($event)"
              (touchend)="onPreviewTouchEnd($event)"
            >
              <ng-container *ngIf="!isFileVideo(currentPreview); else videoPreview">
                <app-post-image-cropper
                  [src]="previewUrls[currentPreview]"
                  [aspect]="postAspect"
                  [(transform)]="cropTransforms[currentPreview]"
                ></app-post-image-cropper>
              </ng-container>
              <ng-template #videoPreview>
                <video [src]="previewUrls[currentPreview]" controls></video>
              </ng-template>

              <button
                class="ig-create-preview__nav ig-create-preview__nav--prev"
                *ngIf="currentPreview > 0"
                (click)="prevPreview()"
              >
                <i class="pi pi-chevron-left"></i>
              </button>
              <button
                class="ig-create-preview__nav ig-create-preview__nav--next"
                *ngIf="currentPreview < previewUrls.length - 1"
                (click)="nextPreview()"
              >
                <i class="pi pi-chevron-right"></i>
              </button>

              <div class="ig-create-preview__dots" *ngIf="previewUrls.length > 1">
                <span
                  *ngFor="let u of previewUrls; let i = index"
                  class="ig-create-preview__dot"
                  [class.ig-create-preview__dot--active]="i === currentPreview"
                  (click)="currentPreview = i"
                ></span>
              </div>
            </div>
          </div>

          <div class="ig-create-aspect" *ngIf="isFileImage(currentPreview)">
            <i class="pi pi-images ig-create-aspect__icon"></i>
            <button type="button" *ngFor="let a of aspectOptions"
                    class="ig-create-aspect__chip"
                    [class.ig-create-aspect__chip--active]="postAspect === a.value"
                    [attr.aria-label]="a.nameKey | transloco"
                    [attr.aria-pressed]="postAspect === a.value"
                    [pTooltip]="a.nameKey | transloco"
                    tooltipPosition="top"
                    (click)="setAspect(a.value)">
              <span class="ig-create-aspect__shape"
                    [style.width.px]="aspectShapeW(a.value)"
                    [style.height.px]="aspectShapeH(a.value)"></span>
            </button>
          </div>

          <div class="ig-create-preview__thumbs" *ngIf="previewUrls.length > 1"
               cdkDropList cdkDropListOrientation="horizontal"
               (cdkDropListDropped)="onThumbDrop($event)">
            <div
              class="ig-create-preview__thumb"
              *ngFor="let u of previewUrls; let i = index"
              cdkDrag
              [class.ig-create-preview__thumb--active]="i === currentPreview"
              (click)="currentPreview = i"
            >
              <img [src]="u" alt="" draggable="false" />
              <button class="ig-create-preview__thumb-remove" (click)="removeFile(i); $event.stopPropagation()">
                <i class="pi pi-times"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- RIGHT: details panel -->
        <div class="ig-create-details">
          <div class="ig-create-details__user">
            <div class="ig-create-details__avatar">
              <i class="pi pi-user"></i>
            </div>
            <span class="ig-create-details__username">{{ currentUserDisplayName || currentUserId }}</span>
          </div>

          <textarea
            class="ig-create-details__caption"
            [(ngModel)]="createCaption"
            (input)="onCaptionInput()"
            [maxlength]="captionMaxLength"
            [placeholder]="'socialFeed.caption' | transloco"
          ></textarea>

          <div class="ig-create-details__caption-count">
            {{ createCaptionLength }}/{{ captionMaxLength }}
          </div>

          <div class="ig-create-details__section ig-create-details__project" *ngIf="selectedProjectId">
            <label>{{ "socialFeed.publishingTo" | transloco }}</label>
            <div class="ig-create-details__project-badge">
              <img
                *ngIf="getSelectedProjectImage()"
                [src]="getSelectedProjectImage()"
                alt=""
              />
              <div *ngIf="!getSelectedProjectImage()" class="ig-create-details__project-fallback">
                <i class="pi pi-car"></i>
              </div>
              <span class="ig-create-details__project-name">{{ getSelectedProjectName() }}</span>
              <button
                class="ig-create-details__project-change"
                *ngIf="myPublicProjects.length > 1"
                (click)="changeProject()"
                type="button"
              >
                {{ "socialFeed.changeProject" | transloco }}
              </button>
            </div>
          </div>

          <label class="ig-create-details__add-more">
            <i class="pi pi-plus-circle"></i>
            {{ "socialFeed.addMoreMedia" | transloco }}
            <input type="file" multiple accept=".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp,.mp4,video/mp4" (change)="onFilesSelected($event)" />
          </label>

          <div class="ig-create-details__spacer"></div>
        </div>
      </div>

      <!-- Overlay de progresso da publicação -->
      <div class="ig-create-overlay" *ngIf="creating" role="status" aria-live="polite">
        <div class="ig-create-overlay__card">
          <div class="ig-create-overlay__spinner"></div>
          <h3 class="ig-create-overlay__title">
            {{
              (creatingStep === 'publishing'
                ? 'socialFeed.publishingTitle'
                : 'socialFeed.uploadingTitle'
              ) | transloco
            }}
          </h3>
          <p class="ig-create-overlay__sub" *ngIf="creatingStep === 'uploading' && creatingFileTotal > 0">
            {{ 'socialFeed.uploadingFile' | transloco: { current: creatingFileIndex, total: creatingFileTotal } }}
          </p>
          <p class="ig-create-overlay__sub" *ngIf="creatingStep === 'publishing'">
            {{ 'socialFeed.publishingHint' | transloco }}
          </p>
          <div class="ig-create-overlay__progress" *ngIf="creatingStep === 'uploading' && creatingFileTotal > 0">
            <div class="ig-create-overlay__progress-bar"
                 [style.width.%]="(creatingFileIndex / creatingFileTotal) * 100">
            </div>
          </div>
          <p class="ig-create-overlay__warn">
            {{ 'socialFeed.dontCloseWindow' | transloco }}
          </p>
        </div>
      </div>
    </ng-container>
  </p-dialog>

  <app-social-report-dialog #reportDialog></app-social-report-dialog>
